export const getOnline = (state) => state?.notifications?.online;

export const getNotificationById = (state, id) => state.notifications.notifications[id];

export const getNotifications = (state) =>
  Object.values(state.notifications.notifications).toSorted((a, b) => a.createdAt - b.createdAt);

export const getLastOpenedAt = (state) => state.notifications.lastOpenedAt;

export const getNotificationFilters = (state) => state.notifications.filters;
